import React from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldCheckBox,
  FieldDatepicker,
} from 'motion-components';
import { useTranslation } from 'react-i18next';

/** Φίλτρα εντύπων που δεν έχουν ακόμα καταχωρηθεί παραλαβή */
export function buildWhereFromFilterValues(values): string {
  let where: Record<string, unknown> = {
    dateStorage: { $eq: null },
    isCancelled: false,
  };

  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ identificationDocument: likeObj }, { driverFullName: likeObj }],
      };
    }
    if (values.startDate || values.endDate) {
      where = {
        ...where,
        ...buildWhereForDates(values.startDate, values.endDate, 'dateCollected'),
      };
    }
  }

  return JSON.stringify(where);
}

export const Filters = ({
  onChange,
  initialValues,
  disable = false,
}: {
  onChange: (values: any) => void;
  initialValues?: any;
  disable?: boolean;
}) => {
  const { t } = useTranslation();

  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    startDate: initialValues?.startDate ?? null,
    endDate: initialValues?.endDate ?? null,
    useCustomReceptionDate: initialValues?.useCustomReceptionDate ?? true,
    defaultReceptionDate: initialValues?.defaultReceptionDate ?? new Date(),
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση (Αρ. Εντύπου, Ον. Οδηγού)')}
          type="search"
          disable={disable}
        />
        <FieldDateRanger
          as={FormCol}
          label={t('Συλλογή από')}
          label2={t('Έως')}
          name="startDate"
          name2="endDate"
        />
      </Row>
      <Row className="align-items-end">
        <FieldCheckBox
          as={FormCol}
          name="useCustomReceptionDate"
          label={t('Εξατομικευμένη Ημερομηνία & Ώρα Παραλαβής')}
          disable={disable}
        />
        <FieldDatepicker
          as={FormCol}
          name="defaultReceptionDate"
          label={t('Ημ/νία & Ώρα Παραλαβής')}
          hasMask={true}
          placeholder="dd/mm/yyyy HH:mm"
          showTimeSelect
          dateFormat="d/M/yyyy HH:mm"
          timeFormat="HH:mm"
          timeIntervals={15}
          disable={disable}
        />
      </Row>
    </FormFilterCard>
  );
};
